/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssignmentDocument } from './AssignmentDocument';
import {
    AssignmentDocumentFromJSON,
    AssignmentDocumentFromJSONTyped,
    AssignmentDocumentToJSON,
} from './AssignmentDocument';
import type { AssignmentResponse } from './AssignmentResponse';
import {
    AssignmentResponseFromJSON,
    AssignmentResponseFromJSONTyped,
    AssignmentResponseToJSON,
} from './AssignmentResponse';
import type { FormattedAssignmentResponse } from './FormattedAssignmentResponse';
import {
    FormattedAssignmentResponseFromJSON,
    FormattedAssignmentResponseFromJSONTyped,
    FormattedAssignmentResponseToJSON,
} from './FormattedAssignmentResponse';
import type { ResponseType } from './ResponseType';
import {
    ResponseTypeFromJSON,
    ResponseTypeFromJSONTyped,
    ResponseTypeToJSON,
} from './ResponseType';

/**
 * 
 * @export
 * @interface FormattedAssignment
 */
export interface FormattedAssignment {
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    hyperlink?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    hyperlinkDisplayText?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    type?: string;
    /**
     * 
     * @type {Date}
     * @memberof FormattedAssignment
     */
    publicationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof FormattedAssignment
     */
    deadline?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof FormattedAssignment
     */
    responseRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    group?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    examiner?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    status?: string;
    /**
     * 
     * @type {Array<AssignmentDocument>}
     * @memberof FormattedAssignment
     */
    assignmentDocuments?: Array<AssignmentDocument>;
    /**
     * 
     * @type {Array<AssignmentResponse>}
     * @memberof FormattedAssignment
     */
    assignmentResponses?: Array<AssignmentResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormattedAssignment
     */
    assignmentTags?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FormattedAssignment
     */
    pinToTop?: boolean;
    /**
     * 
     * @type {ResponseType}
     * @memberof FormattedAssignment
     */
    responseType?: ResponseType;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    deadlineFormatted?: string;
    /**
     * 
     * @type {string}
     * @memberof FormattedAssignment
     */
    publicationFormatted?: string;
    /**
     * 
     * @type {Array<FormattedAssignmentResponse>}
     * @memberof FormattedAssignment
     */
    formattedAssignmentResponses?: Array<FormattedAssignmentResponse>;
}

/**
 * Check if a given object implements the FormattedAssignment interface.
 */
export function instanceOfFormattedAssignment(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormattedAssignmentFromJSON(json: any): FormattedAssignment {
    return FormattedAssignmentFromJSONTyped(json, false);
}

export function FormattedAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormattedAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'hyperlink': !exists(json, 'Hyperlink') ? undefined : json['Hyperlink'],
        'hyperlinkDisplayText': !exists(json, 'HyperlinkDisplayText') ? undefined : json['HyperlinkDisplayText'],
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'publicationDate': !exists(json, 'PublicationDate') ? undefined : (new Date(json['PublicationDate'])),
        'deadline': !exists(json, 'Deadline') ? undefined : (new Date(json['Deadline'])),
        'responseRequired': !exists(json, 'ResponseRequired') ? undefined : json['ResponseRequired'],
        'group': !exists(json, 'Group') ? undefined : json['Group'],
        'examiner': !exists(json, 'Examiner') ? undefined : json['Examiner'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'assignmentDocuments': !exists(json, 'AssignmentDocuments') ? undefined : ((json['AssignmentDocuments'] as Array<any>).map(AssignmentDocumentFromJSON)),
        'assignmentResponses': !exists(json, 'AssignmentResponses') ? undefined : ((json['AssignmentResponses'] as Array<any>).map(AssignmentResponseFromJSON)),
        'assignmentTags': !exists(json, 'AssignmentTags') ? undefined : json['AssignmentTags'],
        'pinToTop': !exists(json, 'PinToTop') ? undefined : json['PinToTop'],
        'responseType': !exists(json, 'ResponseType') ? undefined : ResponseTypeFromJSON(json['ResponseType']),
        'deadlineFormatted': !exists(json, 'DeadlineFormatted') ? undefined : json['DeadlineFormatted'],
        'publicationFormatted': !exists(json, 'PublicationFormatted') ? undefined : json['PublicationFormatted'],
        'formattedAssignmentResponses': !exists(json, 'FormattedAssignmentResponses') ? undefined : ((json['FormattedAssignmentResponses'] as Array<any>).map(FormattedAssignmentResponseFromJSON)),
    };
}

export function FormattedAssignmentToJSON(value?: FormattedAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Name': value.name,
        'Description': value.description,
        'Hyperlink': value.hyperlink,
        'HyperlinkDisplayText': value.hyperlinkDisplayText,
        'Type': value.type,
        'PublicationDate': value.publicationDate === undefined ? undefined : (value.publicationDate.toISOString()),
        'Deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'ResponseRequired': value.responseRequired,
        'Group': value.group,
        'Examiner': value.examiner,
        'Status': value.status,
        'AssignmentDocuments': value.assignmentDocuments === undefined ? undefined : ((value.assignmentDocuments as Array<any>).map(AssignmentDocumentToJSON)),
        'AssignmentResponses': value.assignmentResponses === undefined ? undefined : ((value.assignmentResponses as Array<any>).map(AssignmentResponseToJSON)),
        'AssignmentTags': value.assignmentTags,
        'PinToTop': value.pinToTop,
        'ResponseType': ResponseTypeToJSON(value.responseType),
        'DeadlineFormatted': value.deadlineFormatted,
        'PublicationFormatted': value.publicationFormatted,
        'FormattedAssignmentResponses': value.formattedAssignmentResponses === undefined ? undefined : ((value.formattedAssignmentResponses as Array<any>).map(FormattedAssignmentResponseToJSON)),
    };
}

